import * as _4 from 'lodash4';

export class RouterHelper {
  constructor(private $state: ng.ui.IStateService, private $timeout: ng.ITimeoutService, private log: any) {}

  isValidState(stateName: string): boolean {
    return !_4.isNull(this.$state.href(stateName));
  }
}

angular.module('capability-ng-global').service('routerHelper', RouterHelper);



// WEBPACK FOOTER //
// ./app/lib/global/servants/router_helper.ts